import * as RadixPopover from '@radix-ui/react-popover';
import { cn } from '@/shared/lib/cn';
import type { ComponentProps } from 'react';

export const Popover = RadixPopover.Root;
export const PopoverTrigger = RadixPopover.Trigger;
export const PopoverAnchor = RadixPopover.Anchor;
export const PopoverClose = RadixPopover.Close;

/** Portal'lı, temalı popover içeriği (combobox / lookup / tarih seçici gibi açılır paneller). */
export function PopoverContent({
  className,
  sideOffset = 4,
  ...props
}: ComponentProps<typeof RadixPopover.Content>) {
  return (
    <RadixPopover.Portal>
      <RadixPopover.Content
        sideOffset={sideOffset}
        collisionPadding={8}
        /*
         * Tekerlek olayı BELGEYE ulaşmasın.
         *
         * Diyalog açıkken Radix sayfayı `react-remove-scroll` ile kilitliyor; o kilit
         * `document` üzerindeki wheel dinleyicisinde pencerenin DOM alt ağacı dışında
         * kalan her kaydırmayı `preventDefault` ile iptal ediyor. Popover içeriği
         * `body`ye portallandığı için "dışarısı" sayılıyor ve popup formdaki lookup
         * listeleri tekerlekle kaydırılamıyordu (#437; ölçüm: scrollHeight 1770,
         * clientHeight 288, scrollTop 0'da takılı).
         *
         * Menü/seçim bileşenleri bundan etkilenmiyor: onlar kipli (modal) açıldığı için
         * kendi kilitlerini yığına koyup diyalogunkini devre dışı bırakıyor. Popover
         * kipsiz olduğundan bu yolu kendimiz kesiyoruz: olay `document`e varmıyor,
         * `preventDefault` çağrılmıyor, tarayıcı doğal kaydırmayı yapıyor. Diyalog
         * açıkken `body` zaten `overflow:hidden`, dolayısıyla arkadaki sayfa kaymaz;
         * liste de `overscroll-contain` ile zincirlemeyi kesiyor.
         */
        onWheel={(e) => e.stopPropagation()}
        onTouchMove={(e) => e.stopPropagation()}
        className={cn(
          'border-border bg-bg-elevated text-fg z-50 rounded-md border text-sm shadow-[var(--shadow)] outline-none',
          'data-[state=open]:animate-in data-[state=open]:fade-in',
          className,
        )}
        {...props}
      />
    </RadixPopover.Portal>
  );
}
